import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { TooltipDirectiveModule } from '@toro/common/shared/directives';
import { ChartsModule } from '../../charts/charts.module';
import { RewardsComponent } from './rewards.component';

@NgModule({
    imports: [
        TooltipDirectiveModule,
        CommonModule,
        SvgIconModule,
        RouterModule,
        ChartsModule,
    ],
    exports: [ RewardsComponent ],
    declarations: [ RewardsComponent ],
    entryComponents: [ RewardsComponent ],
})
export class RewardsModule {}
